import { useMemo } from 'react';
import { useLanguage } from './useLanguage';

// Import translation files statically (webpack requires static imports)
import newAnalyticsTranslations from '../ProtoType/NewAnalytics/translations.json';
import breadcrumbTranslations from '../ProtoType/NewAnalytics/AnalyticsBreadcrumb/translations.json';
import dashboardTranslations from '../ProtoType/NewAnalytics/AnalyticsDashboard/translations.json';
import copilotTranslations from '../app/audit/AI/Copilot/translations.json';
import chatHistoryModalTranslations from '../app/audit/AI/Copilot/components/ChatHistoryModal/translations.json';
import promptModalTranslations from '../app/audit/AI/Copilot/PromptModal/translations.json';
import dataSourceDrawerTranslations from '../app/audit/AI/Copilot/components/DataSourceDrawer/translations.json';
import thematicsTranslations from '../ProtoType/CopilotV2/Functions/Thematics/translations.json';
import roiTranslations from '../ProtoType/CopilotV2/Functions/ROI/translations.json';
import thematicWorkflowTranslations from '../ProtoType/CopilotV2/Workflows/Thematic/translations.json';
import roiHomeTranslations from '../ProtoType/CopilotV2/Workflows/ROIHome/translations.json';
import historyButtonTranslations from '../ProtoType/CopilotV2/Components/HistoryButton/translations.json';
import copilotV2IndexTranslations from '../ProtoType/CopilotV2/index/translations.json';
import roiCardTranslations from '../ProtoType/CopilotV2/Components/ROICard/translations.json';
import roiReportTranslations from '../ProtoType/CopilotV2/Components/ROIReport/translations.json';
import thematicCardTranslations from '../ProtoType/CopilotV2/Components/ThematicCard/translations.json';
import thematicsCardsTranslations from '../ProtoType/CopilotV2/Components/ThematicsCards/translations.json';
import filtersTranslations from '../ProtoType/CopilotV2/Components/Filters/translations.json';
import simpleDashboardTranslations from '../app/audit/simple/Dashboard/translations.json';
import cultureMapTranslations from '../app/audit/simple/components/CultureMap/translations.json';
import permissionsModalTranslations from '../app/audit/simple/PermissionsModal/translations.json';
import emptyTranslations from '../app/audit/simple/Empty/translations.json';
import simpleFiltersTranslations from '../app/audit/simple/Filters/translations.json';
import anchorTranslations from '../app/audit/simple/Anchor/translations.json';
import questionAnalyticsTranslations from '../app/audit/simple/QuestionAnalytics/translations.json';
import heatmapTranslations from '../app/audit/simple/Heatmap/translations.json';
import questionTranslations from '../app/audit/simple/question/translations.json';
import factorTranslations from '../app/audit/simple/factor/translations.json';
import factorContentTranslations from '../app/audit/simple/factor/FactorContent/translations.json';
import outcomeContentTranslations from '../app/audit/simple/factor/OutcomeContent/translations.json';
import emptyFeedbackTranslations from '../app/audit/simple/components/EmptyFeedback/translations.json';
import benchmarkTranslations from '../app/audit/simple/Benchmark/translations.json';
import questionsTranslations from '../app/audit/simple/Questions/translations.json';
import navigationTranslations from '../app/audit/simple/Navigation/translations.json';
import aiCopilotTranslations from '../app/audit/simple/components/AICopilot/translations.json';
import staplesReportsTranslations from '../ProtoType/StaplesReports/translations.json';
import correlationsTranslations from '../app/audit/simple/correlations/translations.json';
import feedbackTranslations from '../app/audit/simple/Feedback/translations.json';
import feedbackTagTranslations from '../app/audit/simple/FeedbackTag/translations.json';
import chatModalTranslations from '../app/audit/simple/components/ChatModal/translations.json';
import questionDropdownTranslations from '../app/audit/simple/QuestionDropdown/translations.json';
import errorTranslations from '../error/translations.json';
import automatedReportsTranslations from '../ProtoType/AutomatedReports/translations.json';
import statusHelpersTranslations from '../utilities/statusHelpers/translations.json';

// Translation file mapping
const translationMap = {
  'ProtoType/NewAnalytics/translations': newAnalyticsTranslations,
  'ProtoType/NewAnalytics/AnalyticsBreadcrumb/translations': breadcrumbTranslations,
  'ProtoType/NewAnalytics/AnalyticsDashboard/translations': dashboardTranslations,
  'app/audit/AI/Copilot/translations': copilotTranslations,
  'app/audit/AI/Copilot/components/ChatHistoryModal/translations': chatHistoryModalTranslations,
  'app/audit/AI/Copilot/PromptModal/translations': promptModalTranslations,
  'app/audit/AI/Copilot/components/DataSourceDrawer/translations': dataSourceDrawerTranslations,
  'ProtoType/CopilotV2/Functions/Thematics/translations': thematicsTranslations,
  'ProtoType/CopilotV2/Functions/ROI/translations': roiTranslations,
  'ProtoType/CopilotV2/Workflows/Thematic/translations': thematicWorkflowTranslations,
  'ProtoType/CopilotV2/Workflows/ROIHome/translations': roiHomeTranslations,
  'ProtoType/CopilotV2/Components/HistoryButton/translations': historyButtonTranslations,
  'ProtoType/CopilotV2/index/translations': copilotV2IndexTranslations,
  'ProtoType/CopilotV2/Components/ROICard/translations': roiCardTranslations,
  'ProtoType/CopilotV2/Components/ROIReport/translations': roiReportTranslations,
  'ProtoType/CopilotV2/Components/ThematicCard/translations': thematicCardTranslations,
  'ProtoType/CopilotV2/Components/ThematicsCards/translations': thematicsCardsTranslations,
  'ProtoType/CopilotV2/Components/Filters/translations': filtersTranslations,
  'app/audit/simple/Dashboard/translations': simpleDashboardTranslations,
  'app/audit/simple/components/CultureMap/translations': cultureMapTranslations,
  'app/audit/simple/PermissionsModal/translations': permissionsModalTranslations,
  'app/audit/simple/Empty/translations': emptyTranslations,
  'app/audit/simple/Filters/translations': simpleFiltersTranslations,
  'app/audit/simple/Anchor/translations': anchorTranslations,
  'app/audit/simple/QuestionAnalytics/translations': questionAnalyticsTranslations,
  'app/audit/simple/Heatmap/translations': heatmapTranslations,
  'app/audit/simple/question/translations': questionTranslations,
  'app/audit/simple/factor/translations': factorTranslations,
  'app/audit/simple/factor/FactorContent/translations': factorContentTranslations,
  'app/audit/simple/factor/OutcomeContent/translations': outcomeContentTranslations,
  'app/audit/simple/components/EmptyFeedback/translations': emptyFeedbackTranslations,
  'app/audit/simple/Benchmark/translations': benchmarkTranslations,
  'app/audit/simple/Questions/translations': questionsTranslations,
  'app/audit/simple/Navigation/translations': navigationTranslations,
  'app/audit/simple/components/AICopilot/translations': aiCopilotTranslations,
  'ProtoType/StaplesReports/translations': staplesReportsTranslations,
  'app/audit/simple/correlations/translations': correlationsTranslations,
  'app/audit/simple/Feedback/translations': feedbackTranslations,
  'app/audit/simple/FeedbackTag/translations': feedbackTagTranslations,
  'app/audit/simple/components/ChatModal/translations': chatModalTranslations,
  'app/audit/simple/QuestionDropdown/translations': questionDropdownTranslations,
  'error/translations': errorTranslations,
  'ProtoType/AutomatedReports/translations': automatedReportsTranslations,
  'utilities/statusHelpers/translations': statusHelpersTranslations,
};

/**
 * Hook to load and use per-page translations
 * @param {string} translationPath - Path to translation file (e.g., 'ProtoType/NewAnalytics/translations')
 * @returns {Function} t function that takes a key and returns translated string
 */
export const usePageTranslations = (translationPath) => {
  const { language } = useLanguage();

  const translations = useMemo(() => {
    const translationFile = translationMap[translationPath];
    if (!translationFile) {
      console.warn(`Translation file not found for path: ${translationPath}`);
      return {};
    }
    return translationFile || {};
  }, [translationPath]);

  const t = useMemo(() => {
    return (key, replacements = null) => {
      if (!key) return key;
      
      const translation = translations[key];
      if (!translation) {
        // If translation key doesn't exist, return the key itself
        return key;
      }

      // Get translated string
      let translatedString = translation[language] || translation.en || key;

      // Apply replacements if provided (for strings like "Showing {start}-{end} of {total} results")
      if (replacements && typeof replacements === 'object') {
        Object.keys(replacements).forEach((placeholder) => {
          translatedString = translatedString.replace(
            new RegExp(`\\{${placeholder}\\}`, 'g'),
            replacements[placeholder]
          );
        });
      }

      return translatedString;
    };
  }, [translations, language]);

  return t;
};

